
import CommensHead from '@/components/comments/CommensHead.vue' // 头部

export default {
  components: {
    CommensHead
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    state: {
      // 1用户中心 2评价列表 3曝光列表
      type: [Number, String],
      default: 1
    },
    item: {
      // 渲染的单挑数据
      type: Object,
      default: () => {}
    },
    showReply: {
      // 是否显示回复
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      textState: false,
      text: '',
      dealepop: false,
      dealetxt: '请至企业版删除该回复',
      from: ''
    }
  },
  created() {},
  mounted() {
    const url = window.location.href
    if (url.includes('/usercenter/')) {
      this.from = 'usercenter'
    }
    console.log('item', this.item)
  },
  methods: {
    cancellation() {
      this.textState = false
      this.text = ''
    },
    async reply() {
      // 回复
      if (!this.textState) return (this.textState = true)
      if (!this.text || this.text.length < 10)
        return this.$message({
          message: this.$v('回复内容至少输入10个字'),
          type: 'error',
          duration: 1500
        })
      const ret = await this.$api.common.CV3(
        {
          content: this.text,
          userId: this.$store.state.user.userId || '',
          commentGradeId: this.item.tokenGradeCommentInfo.commentGradeId
        },
        {
          Routes: 'wikicommunity$officialreply'
        }
      )
      console.log('ret: ', ret)
      if (ret && ret.wikicommunity && ret.wikicommunity.officialreply) {
        if (!ret.wikicommunity.officialreply.success) {
          this.$message({
            message: ret.wikicommunity.officialreply.extra,
            type: 'error'
          })
        } else {
          this.textState = false
          this.$emit('getlist', this.$parent.tabIndex)
        }
      }
    },
    async deletereply() {
      const ret = await this.$api.common.CV3(
        {
          userId: this.$store.state.user.userId || '',
          replyId: this.item.officialReply.replyId
        },
        {
          Routes: 'wikicommunity$officialdelete'
        }
      )
      console.log('ret: ', ret)
      if (ret && ret.wikicommunity && ret.wikicommunity.officialdelete) {
        if (!ret.wikicommunity.officialdelete.success) {
          this.dealetxt = ret.wikicommunity.officialdelete.message
          this.dealepop = true

          // this.$message({
          //   message: ret.wikicommunity.officialdelete.message,
          //   type: 'error'
          // })
        } else {
          this.$emit('getlist', this.$parent.tabIndex)
        }
      }
    }
  }
}
